import React from "react";

export const Divider = () => (
  <div className={`border border-[#C6CCE8] w-full my-[40px]`}></div>
);
